//—— 故事頁那四塊命書面板的「先發請求」——
//
//  為什麼要一個模組層的暫存，而不是跟 intake 一樣用 location state 傳：
//  那四段是 AI 生的，要五秒左右。而送出的時機（問診填完）
//  比用到的時機（故事頁掛載）早了十七秒半 —— 中間隔著兩支不能跳過的影片
//  （白夜低頭看竹冊 9.5 秒 + 他批命 8 秒）。
//
//  location state 只能帶「已經有的值」，帶不了「還在路上的請求」。
//  硬要等請求回來再換頁的話，就等於把那五秒變成一段卡住的黑畫面 ——
//  而我們本來有十七秒半的劇情可以拿來掩護它。
//
//  所以這裡存的是 Promise 不是結果：
//    劇情頁在問診結束時呼叫 start()，不 await
//    故事頁掛載時呼叫 take()，await 它
//  故事頁先到就等一下，請求先到就立刻有值。
//
//  —— 為什麼模組層的可變狀態在這裡是對的 ——
//  它跟著這一次瀏覽的生命週期走：重新整理就沒了。
//  但 intake 本來也是用 location state 傳的、重整一樣會沒，
//  故事頁遇到沒有 intake 就會把人導回劇情頁重填。兩者消失的時機一致，
//  不會出現「有問診資料但沒有命書」或反過來的狀態。
//
//  單發（single flight）：同一份問診資料只會真的打一次。
//  這不只是省錢 —— React 嚴格模式下 effect 會跑兩遍，
//  不擋的話每個使用者都會燒掉兩次 API 呼叫，而且兩份結果還不一樣
//  （temperature 0.9），後到的那份會蓋掉先到的。
//
//  換一份問診資料（使用者按返回改了答案再走一次）就重打 ——
//  所以比對的是問診內容本身，不是單純的「打過了沒」。

import generalService from "../../../service/general-service";

let pending = null;
let pendingKey = "";

//什麼算「同一份問診資料」。
//  只取會影響生成結果的欄位：排盤要生辰與性別，寫文案要他填的現況與煩惱。
//  信箱與姓名不算 —— 改了信箱不該重生一次（而且生成根本用不到）。
const keyOf = (intake) =>
  JSON.stringify([
    intake?.birthDate,
    intake?.birthTime,
    intake?.birthPlace?.label,
    intake?.gender,
    intake?.relation,
    intake?.orientation,
    intake?.relationship,
    intake?.career,
    intake?.concern,
  ]);

//故事頁一掛載就呼叫，不要 await。
//  回傳的 Promise 永遠 resolve（失敗時 resolve 成 null）——
//  沒有人 await 它的時候，一個 reject 會變成 unhandled rejection。
export const startTeaser = (intake) => {
  const key = keyOf(intake);
  if (pending && pendingKey === key) return pending;

  pendingKey = key;
  pending = generalService
    .baiyeTeaser(intake)
    .then(({ data }) => (data?.status ? data.data : null))
    .catch((e) => {
      console.warn("[白夜] 命書生成失敗", e?.message);
      return null;
    });
  return pending;
};

//故事頁掛載時呼叫。沒有先發過就回 null（例如直接貼網址進故事頁）。
export const takeTeaser = () => pending;
